// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

// eslint-disable-next-line import/no-cycle -- please fix if you can
import {deepLinkBlockWrapperStyles} from '../deepLinkBlock';

export const WeavePanelWrapper = styled.div`
  white-space: normal;
  margin-bottom: 24px;
  ${deepLinkBlockWrapperStyles}
`;
